import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  allCompaniesData: [],
};

export const companiesSlice = createSlice({
  name: 'companies',
  initialState,
  reducers: {
    setCompanies: (state, action) => {
      state.allCompaniesData = action.payload.allCompaniesData;
      return state;
    },
    
    resetCompanies: () => {
      return initialState;
    },
  },
});

export const { setCompanies, resetCompanies } = companiesSlice.actions;

export default companiesSlice.reducer;
